// Datepicker setup
import 'tempusdominus-bootstrap-4';
import OnloadHandler from 'onload_handler';

(function () {

  const setupDatepickers = function(){
    $('.datepicker').datetimepicker({
      format: 'L',
      locale: 'it'
    });
  }

  const setupDatetimepickers = function(){
    $('.datetimepicker').datetimepicker({
      locale: 'it'
    });
  }

  OnloadHandler(function(){
    setupDatepickers();
    setupDatetimepickers();
  });
})();